import { render, staticRenderFns } from "./opinionCard.vue?vue&type=template&id=0f04969d&scoped=true&"
import script from "./opinionCard.vue?vue&type=script&lang=js&"
export * from "./opinionCard.vue?vue&type=script&lang=js&"
import style0 from "./opinionCard.vue?vue&type=style&index=0&id=0f04969d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04969d",
  null
  
)

export default component.exports